import { RecipeComment } from '../api/Types';
import { SupabaseService, supabase } from './SupabaseClient';
import { notificationService } from './NotificationService';
import { serviceMappers } from './serviceMappers';
import {
    deleteCommentRecord,
    getCommentRecordById,
    insertCommentRecord,
    listCommentsByRecipeId,
    updateCommentRecord,
} from './commentPersistence';
import { notifyCommentCreatedSafely } from './commentNotifications';

export class CommentService extends SupabaseService {
    private normalizeComment(comment: RecipeComment): RecipeComment {
        return serviceMappers.normalizeRecipeComment(comment);
    }

    private normalizeCommentList(comments: RecipeComment[]): RecipeComment[] {
        return serviceMappers.normalizeRecipeComments(comments);
    }

    public async getComments(recipeId: string): Promise<RecipeComment[]> {
        const comments = await listCommentsByRecipeId(supabase, recipeId);
        return this.normalizeCommentList(comments);
    }

    public async getCommentById(commentId: number): Promise<RecipeComment | null> {
        const comment = await getCommentRecordById(supabase, commentId);
        if (!comment) {
            return null;
        }

        return this.normalizeComment(comment);
    }

    public async addComment(commentData: { recipe_id: string; author_id: number; comment: string; }): Promise<RecipeComment> {
        const supabaseClient = await this.getClient();
        const createdComment = await insertCommentRecord(supabaseClient, commentData);
        const normalizedComment = this.normalizeComment(createdComment);
        notifyCommentCreatedSafely(notificationService, createdComment);
        return normalizedComment;
    }

    public async updateComment(commentId: number, comment: string): Promise<RecipeComment> {
        const supabaseClient = await this.getClient();
        const updatedComment = await updateCommentRecord(supabaseClient, commentId, comment);
        return this.normalizeComment(updatedComment);
    }

    public async deleteComment(commentId: number): Promise<void> {
        const supabaseClient = await this.getClient();
        await deleteCommentRecord(supabaseClient, commentId);
    }
}

export const commentService = new CommentService();
